export enum ErrorCode {
  // App Errors (3000-3999)
  APP_INITIALIZATION_FAILED = 3000,
  APP_STATE_CORRUPTED = 3001,
  APP_STORAGE_FAILED = 3002,
  APP_NETWORK_ERROR = 3003,
}

export interface AppError extends Error {
  code: ErrorCode;
  details?: any;
  timestamp: number;
}

export function createError(code: ErrorCode, message: string, details?: any): AppError {
  return {
    name: 'AppError',
    code,
    message,
    details,
    timestamp: Date.now(),
  } as AppError;
}